import { render, staticRenderFns } from "./delete-order.mpx?vue&type=template&id=e2f3fa68&scoped=true&component=true&componentId=delete-order66af43a9"
import script from "./delete-order.mpx?vue&type=script&lang=js&component=true&componentId=delete-order66af43a9"
export * from "./delete-order.mpx?vue&type=script&lang=js&component=true&componentId=delete-order66af43a9"
import style0 from "./delete-order.mpx?vue&type=style&index=0&id=e2f3fa68&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m66af43a9%22%7D&component=true&componentId=delete-order66af43a9"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f3fa68",
  null
  
)

export default component.exports